import {
  Alert,
  Center,
  Stack,
  Title,
  Text,
  Button,
  Paper,
} from '@mantine/core';
import { IconBrandGoogle } from '@tabler/icons-react';
import { useAuth } from '@/hooks/useAuth';
import { Navigate } from 'react-router-dom';
import { readOfflineScopes } from '@/features/events/offline/locators';
import { ScalePadMark } from '@/components/ri/ScalePadMark';
import { TONE_COLOR } from '@/components/ri/statusTones';
import { clearSignedOutReason, readSignedOutReason } from '@/lib/sessionExpiry';

export default function Login() {
  const { login, isAuthenticated, isLoading } = useAuth();
  // Read after bootstrap settles: /login can be mounted while a failed sign-in is still recording why.
  const signedOutReason = isLoading ? null : readSignedOutReason();

  if (isAuthenticated && !isLoading) {
    return <Navigate to="/" replace />;
  }

  const handleLogin = () => {
    clearSignedOutReason();
    login();
  };

  return (
    <Center h="100vh" bg="var(--mantine-color-body)">
      <Paper shadow="md" p="xl" radius="md" w={400}>
        <Stack align="center" gap="lg">
          <ScalePadMark size={40} />
          <Title
            order={2}
            style={{ fontFamily: 'var(--font-brand, "Source Serif 4", serif)' }}
          >
            Meridian
          </Title>
          <Text c="dimmed" size="sm" ta="center">
            ScalePad Account Manager Portal
          </Text>
          {signedOutReason && (
            <Alert
              w="100%"
              radius="md"
              styles={{
                root: { background: TONE_COLOR.info.bg },
                message: { color: TONE_COLOR.info.fg },
              }}
            >
              {signedOutReason === 'expired'
                ? 'You were signed out because your session expired.'
                : "We couldn't finish signing you in. Try again."}
            </Alert>
          )}
          <Button
            fullWidth
            size="md"
            leftSection={<IconBrandGoogle size={20} />}
            onClick={handleLogin}
            loading={isLoading}
          >
            Sign in with Google
          </Button>
          {readOfflineScopes().length > 0 && <Button component="a" href="/events/offline" variant="subtle">Open prepared offline events</Button>}
        </Stack>
      </Paper>
    </Center>
  );
}
